import { render, staticRenderFns } from "./businessmodel.vue?vue&type=template&id=01668ea6&scoped=true&"
import script from "./businessmodel.vue?vue&type=script&lang=js&"
export * from "./businessmodel.vue?vue&type=script&lang=js&"
import style0 from "./businessmodel.vue?vue&type=style&index=0&id=01668ea6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01668ea6",
  null
  
)

export default component.exports